import React from 'react';

export default class Navbar extends React.Component {
  render() {
    return (
      <div>
      <div className="row center-xs center-sm start-md start-lg">
        <div className="col-xs-12">
          <header id="header">
            <nav className="nav">
              <a href='#main'><li>Начало</li></a>
              <a href='#about'><li>О проекте</li></a>
              <a href="#auto"><li>Автомобиль</li></a>
              <a href="#train"><li>Поезд</li></a>
              <a href="#plane"><li>Самолёт</li></a>
              <a href="#hyperloop"><li>Hyperloop</li></a>
              <a href="#ending"><li>Заключение</li></a>
            </nav>
          </header>
        </div>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/Navbar.js